import { useMemo } from 'react';
import { AIR_AMBULANCE } from '@rsos/capstone/src/constants/capabilities';
import { AIR_AMBULANCE_PERMISSION } from '@rsos/constants/permissions';
import useHasCapability from '@rsos/hooks/useHasCapability';
import useHasPermission from '@rsos/hooks/useHasPermission';

const useHasAccessToAirAmbulance = () => {
  const hasAirAmbulanceCapabilities = useHasCapability(AIR_AMBULANCE);
  const hasAirAmbulancePermission = useHasPermission(AIR_AMBULANCE_PERMISSION);
  const hasAccessToAirAmbulanceFeature = useMemo(() => {
    return (
      !!hasAirAmbulanceCapabilities?.hasCapability &&
      !!hasAirAmbulancePermission?.hasPermission
    );
  }, [hasAirAmbulanceCapabilities, hasAirAmbulancePermission]);

  return hasAccessToAirAmbulanceFeature;
};

export default useHasAccessToAirAmbulance;
